import React from 'react';
import { useMapEvent, useMap } from 'react-leaflet';

function EventComponent({ setMarkerSize, potentialSelectedPodcast, setPotentialSelectedPodcast, setSelectedPodcast }) {
  const map = useMap();

  useMapEvent('zoomend', () => {
    const zoom = map.getZoom();
    switch (zoom) {
      case 2:
        setMarkerSize(0.2);
        break;
      case 3:
        setMarkerSize(0.35);
        break;
      case 4:
        setMarkerSize(0.6);
        break;
      case 5:
        setMarkerSize(1.2);
        break;
      default:
        break;
    }

    if (potentialSelectedPodcast) {
      setSelectedPodcast(potentialSelectedPodcast);
      setPotentialSelectedPodcast(null);
    }
  });

  return <></>;
}

export default EventComponent;
